var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 758,
    height: 530,
    viewBox: "0 0 758 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_212)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 758,
    height: 530,
    rx: 20,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 265C479 320.228 434.228 365 379 365C323.772 365 279 320.228 279 265C279 209.772 323.772 165 379 165C434.228 165 479 209.772 479 265Z",
    fill: "#00D743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 265C459 285.122 451.418 304.504 437.764 319.284C424.11 334.065 405.388 343.157 385.33 344.749C365.271 346.341 345.35 340.316 329.535 327.875C313.721 315.433 303.176 297.49 300.002 277.62C296.827 257.75 301.257 237.414 312.408 220.665C323.56 203.916 340.613 191.984 360.169 187.248C379.725 182.512 400.348 185.318 417.927 195.109C435.506 204.9 448.749 220.956 455.018 240.076L442.855 244.064C437.59 228.003 426.465 214.516 411.699 206.292C396.932 198.068 379.609 195.71 363.182 199.688C346.755 203.667 332.43 213.69 323.063 227.759C313.696 241.828 309.975 258.91 312.641 275.601C315.308 292.291 324.166 307.364 337.45 317.815C350.734 328.266 367.468 333.327 384.317 331.989C401.166 330.652 416.893 323.014 428.362 310.599C439.831 298.184 446.2 281.902 446.2 265H459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446 270L459 267V325.025C454.355 331.183 451.475 334.414 446 339.227V270Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351,
    cy: 250,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407,
    cy: 250,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391,
    cy: 514,
    r: 50,
    fill: "#73EAA4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 502,
    cy: 325,
    r: 10,
    fill: "#73EAA4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 13,
    r: 50,
    fill: "#7EE99F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 105,
    r: 30,
    fill: "#7EE99F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113,
    cy: 435,
    r: 15,
    fill: "#7EE99F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 613,
    cy: 220,
    r: 15,
    fill: "#00D743"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 250,
    r: 30,
    fill: "#4CE27B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628,
    cy: 420,
    r: 35,
    fill: "#4CE27B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 294,
    r: 5,
    fill: "#4CE27B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406,
    cy: 144,
    r: 9,
    fill: "#4CE27B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 758,
    height: 530,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji1);
export default __webpack_public_path__ + "static/media/emoji-1.ca8d8a54eb475f86d7ff7875ebfa7de1.svg";
export { ForwardRef as ReactComponent };